var FAVORITES_LOCATION_TYPE = 'userFavouriteDetail';
var PRIVATE_PLANS_LOCATION_TYPE = 'privateOffers';

export { FAVORITES_LOCATION_TYPE, PRIVATE_PLANS_LOCATION_TYPE };
